import axios, { AxiosError } from "axios";

// In dev, Vite proxies /api -> localhost:8000 so a relative URL is fine.
// In prod the SPA and the API live on different origins (SWA vs App Service),
// so the build bakes in VITE_API_PROXY and we hit the API cross-origin.
export const API_BASE = import.meta.env.VITE_API_PROXY ?? "";

export const apiClient = axios.create({
  baseURL: `${API_BASE}/api/v1`,
  // Without an upper bound, a stalled backend leaves the user staring at a
  // permanent loading spinner. 20s is generous enough for a slow B1 cold-bcrypt
  // login but short enough that a real hang surfaces an error.
  timeout: 20000,
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("oneshift_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("oneshift_token");
      if (window.location.pathname !== "/login" && window.location.pathname !== "/signup") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  },
);
